<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiArrowBottomLeft } from "@mdi/js"

export default {
  name: "ArrowBottomLeftIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiArrowBottomLeft,
    }
  }
}
</script>
